import { createAsyncThunk } from '@reduxjs/toolkit'
import CustomerAdministrator from './customer-administrator-model'
import {
  delete_customerAdministrator,
  load_customerAdministrators,
  store_customerAdministrator,
} from './customerAdministrator-service'

export const LoadCustomerAdministratorsAsync = createAsyncThunk<any, any>(
  'composer/load/customerAdministrator',
  async (params: { uid: string }) => {
    return await load_customerAdministrators(params)
  },
)

export const CreateCustomerAdministratorAsync = createAsyncThunk<any, any>(
  'composer/create/customerAdministrator',
  async (params: CustomerAdministrator) => {
    return await store_customerAdministrator(params)
  },
)

export const DeleteCustomerAdministratorAsync = createAsyncThunk<any, any>(
  'composer/delete/customerAdministrator',
  async (params) => {
    return await delete_customerAdministrator(params)
  },
)
